var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('div',{directives:[{name:"click-outside-bemob",rawName:"v-click-outside-bemob",value:(_vm.onClickOutside),expression:"onClickOutside"}],class:{
    'menu-dropdown': true,
    'menu-dropdown--sticked': _vm.computedScrollPosition > 0 
  },style:({
    top: (_vm.pTop + "px"),
    'max-height': (_vm.maxHeight + "px"),
    width: ("calc(100% - " + _vm.scrollWidth + "px)")
  })},[_vm._t("select",null,{"scrollPosition":_vm.computedScrollPosition}),_c('div',{class:_vm.dropdownClass},[_vm._l((_vm.items),function(item){return [_vm._t("item",null,{"item":item})]})],2)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }